<template>
  <div>
    <form>
      <div v-if="isMainArtist">
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">
              {{ mainArtistForm.type === 1 ? 'アーティスト': 'ボーカロイド' }}名
              <span class="req">＊</span>
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div
            class="form-item">
            <input
              id="name_ja"
              v-model.trim="mainArtistForm.name_ja"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_ja')">
            <p
              v-if="mainArtistError.name_ja"
              class="error-text">
              {{ mainArtistError.name_ja[0] }}
            </p>
            <p
              v-else-if="isMainArtist && showWarningMsg"
              class="error-text">
              {{ warningMsg }}
            </p>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_kana">
              {{ mainArtistForm.type === 1 ? 'アーティスト': 'ボーカロイド' }}名（カナ表記）
              <span class="req">＊</span>
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="form-item">
            <input
              id="artist_name_kana"
              v-model.trim="mainArtistForm.name_kana"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_kana')">
            <p
              v-if="mainArtistError.name_kana"
              class="error-text">
              {{ mainArtistError.name_kana[0] }}
            </p>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label form-label--top">
            <label
              class="control-label"
              for="artist_name_en">
              {{ mainArtistForm.type === 1 ? 'アーティスト': 'ボーカロイド' }}名（アルファベット表記）
              <span class="req">＊</span>
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="form-item">
            <input
              id="artist_name_en"
              v-model.trim="mainArtistForm.name_en"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_en')">
            <p
              v-if="mainArtistError.name_en"
              class="error-text">
              {{ mainArtistError.name_en[0] }}
            </p>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">
              {{ featArtistForm.type === 1 ? 'アーティスト': 'ボーカロイド' }}名
              <span class="req">＊</span>
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div
            class="form-item">
            <input
              id="artist_name_domestic"
              v-model.trim="featArtistForm.name_ja"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_ja')">
            <p
              v-if="featuringArtistError.name_ja"
              class="error-text">
              {{ featuringArtistError.name_ja[0] }}
            </p>
            <p
              v-else-if="!isMainArtist && showWarningMsg"
              class="error-text">
              {{ warningMsg }}
            </p>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_kana">
              {{ featArtistForm.type === 1 ? 'アーティスト': 'ボーカロイド' }}名（カナ表記）
              <span class="req">＊</span>
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="form-item">
            <input
              id="artist_name_kana"
              v-model.trim="featArtistForm.name_kana"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_kana')">
            <p
              v-if="featuringArtistError.name_kana"
              class="error-text">
              {{ featuringArtistError.name_kana[0] }}
            </p>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label form-label--top">
            <label
              class="control-label"
              for="artist_name_en">
              {{ featArtistForm.type === 1 ? 'アーティスト': 'ボーカロイド' }}名（アルファベット表記）
              <span class="req">＊</span>
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="form-item">
            <input
              id="artist_name_en"
              v-model.trim="featArtistForm.name_en"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_en')">
            <p
              v-if="featuringArtistError.name_en"
              class="error-text">
              {{ featuringArtistError.name_en[0] }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="c-btn-wrap">
        <a
          class="c-btn c-btn--back c-btn--back-left"
          @click.prevent="showConfirmDialogForArtistCancellation">
          <span>キャンセル</span>
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </a>
        <a
          class="c-btn"
          @click.prevent="onArtistFormSubmit()">
          保存
          <span class="c-btn__icon-arrow"></span>
        </a>
      </div>
    </form>
    <confirm-dialog
      :name="isMainArtist ? 'artistConfirmDialog' : 'featArtistConfirmDialog'"
      :is-shown="showArtistConfirmDialog"
      title="キャンセル"
      @closed="showArtistConfirmDialog = false"
      @cancel-clicked="showArtistConfirmDialog = false"
      @default-clicked="onDefaultClicked">
      <template #body>
        キャンセルします。<br>
        よろしいですか？
      </template>
    </confirm-dialog>
  </div>
</template>
<script>
import { MAIN_ARTIST, FEATURING_ARTIST } from '../consts'
import ConfirmDialog from '../../../../components/ConfirmDialog'

let timer = null
export default {
  name: 'ArtistCreate',
  components: { ConfirmDialog },
  props: {
    belongsTo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mainArtistForm: {
        type: 1,
        name_ja: '',
        name_kana: '',
        name_en: '',
        url: '',
        blog: '',
        genre_ja: '',
        genre_en: '',
        area_ja: '',
        area_en: '',
        profile_ja: '',
        profile_en: '',
        confirmed: true,
      },
      featArtistForm: {
        type: 1,
        name_ja: '',
        name_kana: '',
        name_en: '',
        url: '',
        blog: '',
        genre_ja: '',
        genre_en: '',
        area_ja: '',
        area_en: '',
        profile_ja: '',
        profile_en: '',
        confirmed: true,
      },
      mainArtistError: {},
      featuringArtistError: {},
      showArtistConfirmDialog: false,
      showWarningMsg: false,
      warningMsg: '山田 太郎（TARO YAMADA）など、翻訳表記を含めることはできません。',
    }
  },
  computed: {
    isMainArtist() {
      return this.belongsTo === MAIN_ARTIST
    },
  },
  methods: {
    /**
     * Validate the input field on blur event
     * @param key - field name
     */
    onFieldChanged(key = '') {
      /* display warning message if the japanese and alphabet characters
      along with symbols are entered in japanese name input field */
      if (key === 'name_ja') {
        /* Hiragana: [\u3040-\u309F]
           Katakana: [\u30A0-\u30FF]
           Kanji: [\u4E00-\u9FAF]
         */
        const japaneseRegex = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/
        const alphabetRegex = /[A-Za-z]/
        const specialCharactersRegex = /[()（）\\[\]【】<>＜＞『』]/
        const nameJa = this.isMainArtist ? this.mainArtistForm.name_ja : this.featArtistForm.name_ja
        const containsJapanese = japaneseRegex.test(nameJa)
        const containsAlphabet = alphabetRegex.test(nameJa)
        const containsSpecialCharacters = specialCharactersRegex.test(nameJa)

        this.showWarningMsg = (containsJapanese && containsAlphabet) || containsSpecialCharacters
      }
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => { this.onArtistFormSubmit(key) }, 500)
    },
    async onArtistFormSubmit(key = null) {
      const form = this.belongsTo === MAIN_ARTIST ? this.mainArtistForm : this.featArtistForm
      const config = { headers: { 'X-CMAP-No-Loading': 1 } }
      try {
        const { data } = await window.axios.post('/api/client/artists', form, config)
        this.$emit('notify', { data, belongsTo: this.belongsTo })
        if (key) {
          if (this.belongsTo === MAIN_ARTIST) {
            this.mainArtistError = {}
          }
          if (this.belongsTo === FEATURING_ARTIST) {
            this.featuringArtistError = {}
          }
        }
      } catch ({ response }) {
        const { errors } = response.data
        if (key && !errors.status) {
          if (this.belongsTo === MAIN_ARTIST) {
            this.$set(this.mainArtistError, key, errors[key])
          }
          if (this.belongsTo === FEATURING_ARTIST) {
            this.$set(this.featuringArtistError, key, errors[key])
          }
        } else {
          if (this.belongsTo === MAIN_ARTIST) {
            this.mainArtistError = errors
          }
          if (this.belongsTo === FEATURING_ARTIST) {
            this.featuringArtistError = errors
          }
        }
      }
    },
    showConfirmDialogForArtistCancellation() {
      this.showArtistConfirmDialog = true
    },
    onDefaultClicked() {
      this.showArtistConfirmDialog = false
      if (this.belongsTo === MAIN_ARTIST) {
        this.$emit('cancel', this.belongsTo)
      } else if (this.belongsTo === FEATURING_ARTIST) {
        this.$emit('cancel', this.belongsTo)
      }
    },
  },
}
</script>

<style scoped>
.form-group {
  border-bottom: none;
}
</style>
